import React from "react";
import { Link } from "react-router-dom";
import { shorten, fmtNum } from "../../lib/format";

function typeColor(t) {
  if (t === "CREATE" || t === "CREATE2") return "var(--green)";
  if (t === "DELEGATECALL") return "#B98BF0";
  if (t === "STATICCALL") return "var(--blue)";
  return "var(--amber)";
}

function flatten(root) {
  const rows = [];
  const walk = (node, depth) => {
    rows.push({ node, depth });
    const calls = node.calls || [];
    for (let i = 0; i < calls.length; i++) walk(calls[i], depth + 1);
  };
  walk(root, 0);
  return rows;
}

export default function TraceView({ trace }) {
  if (!trace) {
    return (
      <div className="p-8 text-center text-[13px]" style={{ color: "var(--muted)" }}>
        <i className="fa-solid fa-diagram-project text-2xl mb-2" style={{ color: "var(--border-2)" }} />
        <br />
        Select a transaction to visualize its BCC VM execution trace.
      </div>
    );
  }
  const maxGas = Number(trace.gasUsed || 1);
  const rows = flatten(trace);

  return (
    <div className="p-3 space-y-2">
      {rows.map((row, idx) => {
        const node = row.node;
        const gas = Number(node.gasUsed || 0);
        const pct = maxGas ? Math.min(100, (gas / maxGas) * 100) : 0;
        const color = typeColor(node.type);
        return (
          <div
            key={idx}
            className="trace-node"
            data-testid="trace-node"
            style={{ marginLeft: row.depth * 16, borderLeft: row.depth ? "1px dashed var(--border-2)" : "none", paddingLeft: row.depth ? 12 : 0 }}
          >
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                <span className="pill" style={{ background: color + "22", color: color, border: "1px solid " + color + "44" }}>
                  {node.type}
                </span>
                {node.error ? (
                  <span className="pill pill-red">
                    <i className="fa-solid fa-triangle-exclamation" /> {node.error}
                  </span>
                ) : null}
                <span className="mono text-[11.5px] truncate" style={{ color: "var(--muted)" }}>
                  {node.to ? (
                    <Link to={"/address/" + node.to} className="link-amber">{shorten(node.to, 6, 4)}</Link>
                  ) : (
                    "\u2014"
                  )}
                </span>
              </div>
              <span className="mono text-[11px] shrink-0" style={{ color: "var(--text)" }}>{fmtNum(gas)} gas</span>
            </div>
            <div className="gasbar mt-1.5">
              <span style={{ width: pct + "%" }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
